var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9388 28.2487L13.9388 31.2487C14.5238 31.8352 15.4748 31.8352 16.0598 31.2487L22.0598 25.2487C22.6448 24.6637 22.6448 23.7127 22.0598 23.1277C21.4748 22.5427 20.5238 22.5427 19.9388 23.1277L14.9993 28.0672L13.0598 26.1277C12.4748 25.5427 11.5238 25.5427 10.9388 26.1277C10.3537 26.7127 10.3537 27.6637 10.9388 28.2487Z",
    fill: "#161614"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9388 43.2487L13.9388 46.2487C14.5238 46.8352 15.4748 46.8352 16.0598 46.2487L22.0598 40.2487C22.6448 39.6637 22.6448 38.7127 22.0598 38.1277C21.4748 37.5427 20.5238 37.5427 19.9388 38.1277L14.9993 43.0672L13.0598 41.1277C12.4748 40.5427 11.5238 40.5427 10.9388 41.1277C10.3537 41.7127 10.3537 42.6637 10.9388 43.2487Z",
    fill: "#161614"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9388 58.2487L13.9388 61.2487C14.5238 61.8352 15.4748 61.8352 16.0598 61.2487L22.0598 55.2487C22.6448 54.6637 22.6448 53.7127 22.0598 53.1277C21.4748 52.5427 20.5238 52.5427 19.9388 53.1277L14.9993 58.0672L13.0598 56.1277C12.4748 55.5427 11.5238 55.5427 10.9388 56.1277C10.3537 56.7127 10.3537 57.6637 10.9388 58.2487Z",
    fill: "#161614"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 22.689H27C26.172 22.689 25.5 23.361 25.5 24.189C25.5 25.017 26.172 25.689 27 25.689H48C48.828 25.689 49.5 25.017 49.5 24.189C49.5 23.361 48.828 22.689 48 22.689Z",
    fill: "#161614"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 37.689H27C26.172 37.689 25.5 38.361 25.5 39.189C25.5 40.017 26.172 40.689 27 40.689H39C39.828 40.689 40.5 40.017 40.5 39.189C40.5 38.361 39.828 37.689 39 37.689Z",
    fill: "#161614"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 43.689H27C26.172 43.689 25.5 44.361 25.5 45.189C25.5 46.017 26.172 46.689 27 46.689H36C36.828 46.689 37.5 46.017 37.5 45.189C37.5 44.361 36.828 43.689 36 43.689Z",
    fill: "#161614"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 28.689H27C26.172 28.689 25.5 29.361 25.5 30.189C25.5 31.017 26.172 31.689 27 31.689H39C39.828 31.689 40.5 31.017 40.5 30.189C40.5 29.361 39.828 28.689 39 28.689Z",
    fill: "#161614"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5 45.189V54.189C52.5 54.5865 52.6575 54.969 52.9395 55.2495L58.9395 61.2495C59.5245 61.8345 60.4755 61.8345 61.0605 61.2495C61.6455 60.6645 61.6455 59.7135 61.0605 59.1285L55.5 53.568V45.189C55.5 44.361 54.828 43.689 54 43.689C53.172 43.689 52.5 44.361 52.5 45.189Z",
    fill: "#F30002"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 55.689H33C33.828 55.689 34.5 55.017 34.5 54.189C34.5 53.361 33.828 52.689 33 52.689H27C26.172 52.689 25.5 53.361 25.5 54.189C25.5 55.017 26.172 55.689 27 55.689Z",
    fill: "#161614"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 61.689H33C33.828 61.689 34.5 61.017 34.5 60.189C34.5 59.361 33.828 58.689 33 58.689H27C26.172 58.689 25.5 59.361 25.5 60.189C25.5 61.017 26.172 61.689 27 61.689Z",
    fill: "#161614"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 70.689C53.3925 70.689 19.389 70.689 9 70.689C4.8585 70.689 1.5 67.3305 1.5 63.189C1.5 50.6385 1.5 21.7395 1.5 9.18896C1.5 7.19997 2.29051 5.29197 3.69601 3.88497C5.10301 2.47947 7.011 1.68896 9 1.68896H39.5145C41.5035 1.68896 43.4115 2.47947 44.8185 3.88497L56.304 15.3705C57.7095 16.7775 58.5 18.6855 58.5 20.6745V38.3115C65.4225 40.272 70.5 46.6425 70.5 54.189C70.5 63.2955 63.1065 70.689 54 70.689ZM54 40.689C61.4505 40.689 67.5 46.7385 67.5 54.189C67.5 61.6395 61.4505 67.689 54 67.689C46.5495 67.689 40.5 61.6395 40.5 54.189C40.5 46.7385 46.5495 40.689 54 40.689ZM55.5 37.7565V20.6745C55.5 20.34 55.4625 20.01 55.3905 19.689H48C46.011 19.689 44.103 18.8985 42.696 17.493C41.2905 16.086 40.5 14.178 40.5 12.189V4.79846C40.179 4.72646 39.849 4.68896 39.5145 4.68896C33.4395 4.68896 17.7 4.68896 9 4.68896C7.806 4.68896 6.6615 5.16296 5.8185 6.00746C4.974 6.85046 4.5 7.99496 4.5 9.18896V63.189C4.5 65.6745 6.5145 67.689 9 67.689H44.5155C40.2735 64.7025 37.5 59.7675 37.5 54.189C37.5 45.0825 44.8935 37.689 54 37.689C54.5055 37.689 55.005 37.7115 55.5 37.7565ZM53.379 16.689L43.5 6.80997V12.189C43.5 13.383 43.974 14.5275 44.8185 15.3705C45.6615 16.215 46.806 16.689 48 16.689H53.379Z",
    fill: "#161614"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71 54.189C71 63.5778 63.3888 71.189 54 71.189C44.6112 71.189 37 63.5778 37 54.189C37 44.8001 44.6112 37.189 54 37.189C63.3888 37.189 71 44.8001 71 54.189ZM40.4752 54.189C40.4752 61.6585 46.5304 67.7138 54 67.7138C61.4696 67.7138 67.5248 61.6585 67.5248 54.189C67.5248 46.7194 61.4696 40.6641 54 40.6641C46.5304 40.6641 40.4752 46.7194 40.4752 54.189Z",
    fill: "#F30002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.f3a26e1b7134b57f09cdaf22d44111a2.svg";
export { ForwardRef as ReactComponent };